<template>

    <v-modal :title="$t('labels.create_tag')">
        <template #alert>
            <v-alert-upgrade feature="tags" />
        </template>
        <template #body>
            <v-alert :message="error" />
            <v-modal-section icon="fas fa-cog" :title="$t('labels.settings')">
                <v-form-group :label="$t('labels.name')" required>
                    <v-input :model="params.name" @input="params.name = $event" />
                </v-form-group>
                <v-form-group :label="$t('labels.for')">
                    <v-select :model="params.context" @input="params.context = $event">
                        <option value="review">{{ $t('labels.reviews') }}</option>
                        <option value="customer">{{ $t('labels.customers') }}</option>
                    </v-select>
                </v-form-group>
                <v-form-group :label="$t('labels.color')">
                    <v-input-color :model="params.color" @input="params.color = $event" />
                </v-form-group>
                <v-form-group :label="$t('labels.icon')">
                    <v-icon-scroller :model="params.sprite" @input="params.sprite = $event" />
                </v-form-group>
            </v-modal-section>
            <v-modal-section v-if="params.context === 'review'" icon="fas fa-sparkles" :title="$t('labels.ai_auto_tagging')" :inactive="!params.has_ai_tagging" @input="params.has_ai_tagging = $event">
                <v-form-group :label="$t('labels.instructions')">
                    <v-textarea :max="500" :placeholder="$t('labels.ai_tagging_instructions')" :model="params.ai_instructions" @input="params.ai_instructions = $event" />
                </v-form-group>
                <v-form-group :label="$t('labels.tag_existing_reviews')">
                    <v-checkbox :label="$t('labels.automatically_apply_tags')" :model="params.has_ai_backfill" @input="params.has_ai_backfill = $event" />
                </v-form-group>
            </v-modal-section>
        </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="cancel">{{ $t('labels.cancel') }}</v-button>
            <v-button size="sm" :loading="loading" @click.native="createTag">{{ $t('labels.create') }}</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import Modal from '@cmp/Modal';
import ModalSection from '@cmp/ModalSection';
import IconScroller from '@forms/IconScroller';
import InputColor from '@forms/InputColor';

export default {

    components: {
        'v-icon-scroller': IconScroller,
        'v-input-color': InputColor,
        'v-modal': Modal,
        'v-modal-section': ModalSection,
    },

    props: {
        context: {
            type: String,
            default: 'review',
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                context: this.context,
                color: '#333333',
                sprite: 'fas fa-tag',
            },
        }
    },

    methods: {

        createTag() {
            this.loading = true;
            ProjectApi.createTag(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('messages.saved'));
                    this.$store.commit('setModal', null);
                    this.$emit('saved');
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        cancel() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>
